module.exports = "/assets/3deb3691619a1b0763ec9b4710eaf03b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/expedia-icon.png
// module id = 606
// module chunks = 0